// extracted by mini-css-extract-plugin
module.exports = {"table__card":"subTopic_table__card__1Ziy-"};